import React from 'react';
import PropTypes from 'prop-types';

import styles from './headerImage.module.css';

const HeaderImage = ({ url }) => (
  <div
    style={{
      backgroundImage: `url(${url})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
    className={styles.container}
  >
    {' '}
    {url && <img className={styles.img} src={url} alt="clinic" />}
    <div className={styles.overlay} />
  </div>
);

HeaderImage.propTypes = {
  url: PropTypes.string,
};

export default HeaderImage;
